import XLSX from 'xlsx';

/**
 * Descarga de datos tabulares (columnas + filas) a CSV o XLSX.
 *
 * Movido desde EricChart para poder reusarlo desde la fila de acciones del
 * mensaje (junto a like/dislike/copiar) en EricAnalyst.
 */

// ---- Descarga CSV ----
export function descargarCSV(columnas, filas, nombreArchivo) {
  var lineas = [columnas.join(',')];
  filas.forEach(function(fila) {
    var celdas = columnas.map(function(col) {
      var v = fila[col];
      if (v === null || v === undefined) return '';
      var s = String(v);
      // Escapar si contiene coma, comilla o salto de línea.
      if (s.indexOf(',') !== -1 || s.indexOf('"') !== -1 || s.indexOf('\n') !== -1) {
        return '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    });
    lineas.push(celdas.join(','));
  });
  var contenido = '﻿' + lineas.join('\r\n'); // BOM para que Excel lo abra bien en ES
  var blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nombreArchivo + '.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// ---- Descarga XLSX ----
export function descargarXLSX(columnas, filas, nombreArchivo) {
  var data = [columnas].concat(filas.map(function(fila) {
    return columnas.map(function(col) {
      var v = fila[col];
      return (v === null || v === undefined) ? '' : v;
    });
  }));
  var ws = XLSX.utils.aoa_to_sheet(data);
  var wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Datos');
  XLSX.writeFile(wb, nombreArchivo + '.xlsx');
}

export default { descargarCSV: descargarCSV, descargarXLSX: descargarXLSX };
